import { useState } from "react";
import './Budget.css';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';

function Budget() {
    const [amount, setAmount] = useState('');
    const [displayAmount, setDisplayAmount] = useState('');
    const [isInputVisible, setIsInputVisible] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [expenses, setExpenses] = useState([]); // State for storing expenses
    const [expenseItem, setExpenseItem] = useState('');
    const [expenseCost, setExpenseCost] = useState('');
    const [totalCost, setTotalCost] = useState(0); // State for total cost of expenses
    
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-PH', {
            style: 'currency',
            currency: 'PHP',
        }).format(value);
    };

    const handleKeyUp = (e) => {
        if (e.key === 'Enter') {
            const value = Number(amount);
            if (!isNaN(value) && value >= 0) { 
                setDisplayAmount(formatCurrency(value));
                setIsInputVisible(false);
            } else {
                setDisplayAmount('Please enter a valid number');
            }
        }
    };

    const resetInput = () => {
        setAmount('');
        setDisplayAmount('');
        setIsInputVisible(true);
        setTotalCost(0); // Reset total cost
        setExpenses([]); // Clear expenses
    };

    const addExpense = () => {
        const cost = Number(expenseCost);
        if (expenseItem && cost > 0 && cost <= amount - totalCost) {
            const newExpense = {
                item: expenseItem,
                cost: cost
            };
            setExpenses([...expenses, newExpense]);
            setTotalCost((prevTotal) => prevTotal + cost); // Update total cost
            setExpenseItem('');
            setExpenseCost('');
            setIsModalOpen(false);
        } else {
            alert("Please make sure the expense cost is valid and within your budget.");
        }
    };

    const removeExpense = (index) => {
        const expenseToRemove = expenses[index];
        setExpenses(expenses.filter((_, i) => i !== index)); // Remove expense from list
        setTotalCost((prevTotal) => prevTotal - expenseToRemove.cost); // Update total cost
    };

    const balance = Number(amount - totalCost);

    // Pie Chart Function
    const data = expenses.map(expense => ({
        label: expense.item,
        value: expense.cost,
    }));

    const sizing = {
        margin: { right: 5 },
        width: 200,
        height: 200,
        legend: { hidden: true},
    };

    const getArcLabel = (params) => {
        return params.label; 
    };

    return (
        <div className="containerFour">
            <div className="sectionthree">
                <h3 id="label">Budget Tracking</h3>
            </div>
            {/* Set Budget */}
            <div className="beginBalance">
                {isInputVisible ? (
                    <input
                        type="number"
                        id="setAmount"
                        placeholder="Set Budget"
                        size="30"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        onKeyUp={handleKeyUp}
                    />
                ) : (
                    <div className="displayAmount">
                        <p id="start">Budget: {displayAmount}</p>
                        <button id="reset" onClick={resetInput}>Reset</button>
                        <p id="balance">Balance: {formatCurrency(balance)}</p>                       
                    </div>
                )}
            </div>
            {/* Add Expense */}
            <div className="addExpense">
                <span id="expenseBox" onClick={() => setIsModalOpen(true)}>
                    <i class="fa-solid fa-receipt"></i>
                    Add Expense
                </span>
                {isModalOpen && (
                    <div className="expense-overlay">
                        <div className="expense-modal">
                            <input
                                type="text"
                                placeholder="Expense Item"
                                value={expenseItem}
                                onChange={(e) => setExpenseItem(e.target.value)}
                            />
                            <input
                                type="number"
                                placeholder="Cost"
                                value={expenseCost}
                                onChange={(e) => setExpenseCost(e.target.value)}
                            />
                            <button onClick={addExpense} disabled={balance <= 0}>Add Expense</button>
                            <button onClick={() => setIsModalOpen(false)}>Cancel</button>
                        </div>
                    </div>
                )}
            </div>

            {/* Expense List */}
            <div className="listExpense">
                <h4>List of Expenses:</h4>
                {expenses.length === 0 ? (
                    <p>No expenses yet.</p>
                ) : (
                    expenses.map((expense, index) => (
                        <div key={index} className="expenseItem">
                            <div className="expenseDetails">
                                <span className="expenseName">{expense.item}</span>
                                <span className="expenseCost">{formatCurrency(expense.cost)}</span>
                            </div>
                            <button onClick={() => removeExpense(index)}>X</button>
                        </div>
                        
                    ))
                )}
            </div>

            {/* Pie Chart */}
            <div className="pieChartContainer">
                <PieChart className="pieChart" 
                    series={[
                        {
                            outerRadius: 100,
                            data, 
                            arcLabel: getArcLabel, 
                        },
                    ]}
                    sx={{
                        [`& .${pieArcLabelClasses.root}`]: {
                            fill: 'white',
                            fontSize: 12,
                        },
                    }}
                    {...sizing}
                />
            </div>

        </div>
    );
}

export default Budget;
